<template>
  <div
      :style=getHeight>
    <l-map
        v-if="showMap"
        :options="mapOptions"
        ref="myMap"
    >
      <l-tile-layer
          :url="url"
      />
      <l-geo-json
          :geojson="geojson"
          :options="geoOptions"
      />
    </l-map>
  </div>
</template>

<script>
// If you need to reference 'L', such as in 'L.icon', then be sure to
// explicitly import 'leaflet' into your component
import * as L from 'leaflet';
import {Icon} from 'leaflet';
import {LGeoJson, LMap, LMarker, LPopup, LTileLayer, LTooltip} from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import axios from "axios";


export default {
  name: "TcnMap",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    LGeoJson
  },
  props: {
    value: {type: Array, default: null},
    options: {type: Object, required: true},
    schema: {type: Object, required: true},
    fullSchema: {type: Object, required: true},
    fullKey: {type: String, required: true},
    label: {type: String, default: ''},
    htmlDescription: {type: String, default: ''},
    disabled: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    rules: {type: Array, required: true},
    on: {type: Object, required: true},
  },
  data() {
    return {
      geojson: null,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      mapOptions: {
        zoomSnap: 0.5
      },
      showMap: true
    }
  },
  computed: {
    geoOptions() {
      return {
        onEachFeature: this.onEachFeatureFunction,
        pointToLayer: this.setupMarker
      };
    },

    getHeight() {
      return `height: ${this.schema['height']}` || "height: 600px"
    },

  },
  watch: {},
  methods: {
    async onEachFeatureFunction(feature, layer) {
      let popupContent = ""

      if (feature.properties.address !== null) {
        popupContent += `<p>${feature.properties.address}</p>`
      } else {
        popupContent += `<p>${await this.findAddressByCords(feature.geometry.coordinates[1], feature.geometry.coordinates[0])}</p>`
      }
      if (feature.properties.link !== null) {
        popupContent += `<a href="${feature.properties.link}" target="_blank" style="text-decoration: none">Przejdź</a>`
      }

      layer.bindPopup(popupContent);
    },

    setupMarker(feature, coordinates) {
      const customIcon = new L.Icon({
        iconUrl: feature.properties.iconUrl || require('leaflet/dist/images/marker-icon.png'),
        iconRetinaUrl: feature.properties.iconUrl || require('leaflet/dist/images/marker-icon-2x.png'),
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        shadowSize: [41, 41]
      });

      return L.marker(coordinates,
          {
            icon: customIcon
          }
      )
    },

    async localAddress(item) {
      if (item.address === null) {
        item.address = await this.findAddressByCords(item.marker.lat, item.marker.lng)
      }
    },

    initialZoom() {
      const map = this.$refs.myMap.mapObject
      const points = this.geojson.features.map(item => [item.geometry.coordinates[1], item.geometry.coordinates[0]])
      map.fitBounds(points)
    },

    async findAddressByCords(lat, long) {
      const ENDPOINT = 'https://nominatim.openstreetmap.org/reverse';
      const FORMAT = 'jsonv2';

      let displayName = null
      await axios.get(ENDPOINT, {
        headers: {
          "Accept-Language": "PL"
        },
        params: {
          format: FORMAT,
          lat: lat,
          lon: long,
        }
      }).then((response) => {
        displayName = response.data['display_name']
      })

      return displayName
    },
    // TODO to delete
    // async findCordsFromAddress(address) {
    //   const ENDPOINT = 'https://nominatim.openstreetmap.org/search';
    //   const FORMAT = 'jsonv2';
    //
    //   let cords = null
    //   await axios.get(ENDPOINT, {
    //     headers: {
    //       "Accept-Language": "PL"
    //     },
    //     params: {
    //       format: FORMAT,
    //       q: address,
    //       limit: 1
    //     }
    //   }).then((response) => {
    //     console.log(response)
    //     cords = {latitude: response.data[0].lat, longitude: response.data[0].lon}
    //   })
    //
    //   return cords
    // }
  },
  created() {
    // Config default icon from documentation
    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
      iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });
  },

  async mounted() {
    await this.options.httpLib.get(`${this.schema['x-source']}`)
        .then((response) => {
          this.geojson = response.data
          this.initialZoom()
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {

        })
  }
}
</script>

<style scoped lang="css">
>>> .leaflet-right {
  display: none !important;
}
</style>
